
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/account",
      function () {
        return require("private-next-pages/settings/account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/account"])
      });
    }
  